import { Stack, Table, TableBody, TableHead, TableRow } from '@mui/material';

import {
  ActionIconButton,
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';
import {
  formatInstallments,
} from '../../utils/puntajeFormatters';
import TableStateRow from '../common/TableStateRow';

const InitialBalancesTable = ({ rows, isLoading, pagination, isAdmin, onEdit, onDelete }) => (
  <>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>Grupo</HeadTableCell>
            <HeadTableCell>Anio</HeadTableCell>
            <HeadTableCell>Fondo</HeadTableCell>
            <HeadTableCell sx={{ textAlign: 'right' }}>Saldo en cuotas</HeadTableCell>
            <HeadTableCell>Notas</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows.length ? (
            <TableStateRow
              colSpan={6}
              loading={isLoading}
              emptyMessage="No hay saldos iniciales cargados."
            />
          ) : (
            rows.map((row) => (
              <TableRow key={row.uuid} hover>
                <RowTableCell>{row.group_name || '-'}</RowTableCell>
                <RowTableCell>{row.year}</RowTableCell>
                <RowTableCell>{row.fund_type}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'right', fontWeight: 600 }}>
                  {formatInstallments(row.installments_balance)}
                </RowTableCell>
                <RowTableCell>{row.notes || '-'}</RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <ActionIconButton
                      variant="edit"
                      onClick={() => onEdit(row)}
                      disabled={!isAdmin}
                    />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => onDelete(row)}
                      disabled={!isAdmin}
                    />
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!pagination?.totalCount && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </>
);

export default InitialBalancesTable;
